import { render, staticRenderFns } from "./CursoGestion.vue?vue&type=template&id=0024d3c8&"
import script from "./CursoGestion.vue?vue&type=script&lang=js&"
export * from "./CursoGestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports